import { z } from 'zod';

export const ZDiscountCodeInfo = z.object({
  code: z.string().optional(),
  link: z.string(),
});
